import { useMutation, UseMutationResult } from 'react-query';
import type { ResponseFormat } from '../algebra/global';

import { Http } from '../prelude/http';

export interface IQuickExitRequest {
  messaging_service_key: string;
  task_sid: string;
  captcha_token: Record<string, string>;
}

/**
 * Used for begin Shift.
 * @param appId
 * @param profile
 * Parth Ghiya
 */
export const useQuickExit = (): UseMutationResult<string, unknown, IQuickExitRequest, unknown> => {
  return useMutation(async ({ messaging_service_key, task_sid, captcha_token }) =>
    Http.Request<ResponseFormat<string>>('POST', `/hotlines/api/v1/ingress/webchats.cancel?messaging_service_key=${messaging_service_key}&task_sid=${task_sid}`, captcha_token).then((res) => res.data)
  );
};
